'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.getGalleryData = getGalleryData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GALLERY_LOAD = 'ms/gallery/load';
var GALLERY_LOAD_SUCCESS = 'ms/gallery/load_success';
var GALLERY_LOAD_FAIL = 'ms/gallery/load_fail';

var initialState = {
  loading: false,
  loaded: false,
  data: null
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GALLERY_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loaded: false
      });
    case GALLERY_LOAD_SUCCESS:

      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        data: action.result
      });
    case GALLERY_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false
      });
    default:
      return state;
  }
}

function getGalleryData() {
  return function (dispatch, getState) {
    if (!getState().gallery.loaded && !getState().gallery.loading) {
      return dispatch({
        types: [GALLERY_LOAD, GALLERY_LOAD_SUCCESS, GALLERY_LOAD_FAIL],
        promise: function promise(client) {
          return client.get('/v1/gallery').then(function (result) {
            return result.gallery;
          });
        }
      });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/gallery.js
// module id = 400
// module chunks = 0